import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedCubicMeterCalculator from "./SharedCubicMeterCalculator";
const TITLE = "حاسبة المتر المكعب الالكترونية - تعلم كيفية حساب المتر المكعب";
const DESCRIPTION =
  "حاسبة المتر المكعب الإلكترونية: احسب الحجم بدقة لأي جسم أو مساحة بسهولة! تعلم طريقة حساب المتر المكعب للصناديق، الغرف، المواد وغيرها مع أمثلة عملية.";
const KEYWORDS = "حساب المتر المكعب";
const OG_URL = "https://do-calculate.com/calculator/ar/cubicmeter";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                المتر المكعب هو وحدة قياس تُستخدم لحساب السعة أو الحجم لأشكال
                مختلفة. هناك العديد من الأشكال الهندسية التي تتطلب قوانين خاصة
                لحساب حجمها. إذا اعتبرنا مكعبًا بطول 2 متر وعرض 2 متر وارتفاع 2
                متر، يمكننا استخدام معادلة حجم المكعب التي تُمثلها الطول مضروبًا
                في العرض مضروبًا في الارتفاع. هذا يعني أن حجم المكعب سيكون 8 متر
                مكعب.
                <br />
                استخدام المتر المكعب كوحدة قياسية يسهم في تبسيط عمليات حساب
                الحجوم والسعات لمختلف الأشكال الهندسية.
                <br />
                <b>
                  استخدام المتر المكعب كوحدة قياسية يسهم في تبسيط عمليات حساب
                  الحجوم والسعات لمختلف الأشكال الهندسية."
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedCubicMeterCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
